import React, { useState, useEffect } from "react";
import { Row, Col, Card, message, Divider, Tag } from "antd";
import { BarChartOutlined, CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";

export const TreinamentosRelatorioDetalhes = () => {
  const { id_grupo, id_curso, id_filial } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  // DADOS
  const [curso, setCurso] = useState({});
  const [filial, setFilial] = useState({});

  useEffect(() => {
    if (id_curso > 0) {
      carregarCurso(id_curso);
      listarRelatorioDetalhes(id_curso, id_filial);
    }
  }, [id_curso]);

  // CARREGAR
  const carregarCurso = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_cursos/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setCurso(response);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarRelatorioDetalhes = async (id, filial) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_cursos/relatorio_detalhes?filial=${filial}&curso=${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setFilial(response?.filial);
      setDados(response?.relatorio);
    } else {
      navigate("/treinamentos/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const renderStatus = (status) => {
    if (status === 1) {
      return (
        <Tag icon={<CheckCircleOutlined />} color="green">
          Concluído
        </Tag>
      );
    } else if (status === 2) {
      return (
        <Tag icon={<ClockCircleOutlined />} color="processing">
          Em andamento
        </Tag>
      );
    } else if (status === 0) {
      return (
        <Tag icon={<CloseCircleOutlined />} color="default">
          Não Aprovado
        </Tag>
      );
    } else {
      return <Tag color="orange">Não iniciado</Tag>;
    }
  };

  const renderStatusText = (status) => {
    if (status === 1) {
      return "Concluído";
    } else if (status === 2) {
      return "Em andamento";
    } else if (status === 0) {
      return "Não Aprovado";
    }

    return "Não iniciado";
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Colaborador",
      dataIndex: "colaborador",
    },
    {
      title: "Data Recebimento",
      dataIndex: "data_recebimento",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => renderStatus(e?.status),
      renderText: (e) => renderStatusText(e?.status),
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Treinamentos & Desenvolvimento"
              onClickBack={() => navigate(`/treinamentos/grupos/cursos/${id_grupo}/relatorio/${id_curso}`)}
            />
            <HeaderTitle
              title={["Treinamentos & Desenvolvimento", "Relatório", "Detalhes"]}
              subtitle={`${curso?.descricao ?? ""} / ${filial?.descricao}`}
              icon={<BarChartOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom loading={loading} columns={columns} dataSource={dados} />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
